import CollectionTableHelper from './collection-table-helper';
import CollectionFollowersTableHelper from './collection-followers-table-helper';


const CollectionHelpers = {
    TableMain: CollectionTableHelper,
    TableFollowers: CollectionFollowersTableHelper,
}

export default CollectionHelpers;